import React from "react";
import ContentLoader from "react-content-loader";

const AdminCertifiedModeEditLoaderTemplate = (props) => {
    const screenwidth = window.innerWidth;

    return (
        <ContentLoader
            speed={2}
            width="100%"
            height={230}
            viewBox={`0 0 ${screenwidth > 768 ? 768 : screenwidth} 230`}
            backgroundColor="#262729"
            foregroundColor="#2b2b2b"
            {...props}
        >
            {/* Toggle (isActive) */}
            <rect x="0" y="20" rx="6" ry="6" width="120" height="10" />
            <rect x="90%" y="15" rx="10" ry="10" width="10%" height="22" />

            {/* Name input */}
            <rect x="0" y="70" rx="6" ry="6" width="80" height="10" />
            <rect x="0" y="90" rx="6" ry="6" width="100%" height="43" />

            {/* Certifier select */}
            <rect x="0" y="160" rx="6" ry="6" width="80" height="10" />
            <rect x="0" y="180" rx="6" ry="6" width="100%" height="43" />
        </ContentLoader>
    );
};

export default AdminCertifiedModeEditLoaderTemplate;
